// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"StripePayment_contentWrapper__2YWbv","content":"StripePayment_content__3BzCd","flashIcon":"StripePayment_flashIcon__3-hi9"};